module.exports = __webpack_public_path__ + "static/media/talksCardBack.39eff4a9.svg";